module.exports = __webpack_public_path__ + "img/unionpay.8f058632.png";